/*
 * @Descripttion: 新增订单弹窗
 * @Author: renbh
 * @Date: 2023-07-03 14:19:47
 * @LastEditors: 曹博
 * @LastEditTime: 2023-12-01 16:38:00
 */

import CustomModal from '../../../../components/ModalUser'
import { Col, Row, Spin } from 'antd'
import Search from '../../../../components/SearchFilter'
import useAddOrderModalHook, { Props } from './hooks'
import moment from 'moment'
import InfiniteScroll from 'react-infinite-scroll-component'
import TableAntd from '../../../../components/TableAntd'
import { toAssureOperationRender } from '../../../InvoiceEntry/SupplierInvoice'

const columsData = {
  电商供应商订单: {
    columns: [
      {
        key: 'orderNo',
        dataIndex: 'orderNo',
        title: '客户订单号',
        width: 100,
        ellipsis: true,
      },
      {
        key: 'customer',
        dataIndex: 'customer',
        title: '客户名称',
        width: 100,
        ellipsis: true,
      },
      {
        key: 'titleOfTheContract',
        dataIndex: 'titleOfTheContract',
        title: '签约主体',
      },
      {
        key: 'platform',
        dataIndex: 'platform',
        title: '下单平台',
        width: 100,
        ellipsis: true,
      },
      {
        key: 'orderTime',
        dataIndex: 'orderTime',
        title: '下单时间',
        width: 100,
        render: (text: any) => moment(text).format('YYYY-MM-DD HH:mm:ss'),
        ellipsis: true,
      },
      {
        key: 'finalPrice',
        dataIndex: 'finalPrice',
        title: '最终结算金额',
        width: 100,
        ellipsis: true,
      },
    ],
  },
  供应商订单: {
    columns: [
      {
        key: 'code',
        title: '采购订单号',
        render: toAssureOperationRender,
      },
      {
        key: 'createTime',
        dataIndex: 'createTime',
        title: '创建时间',
        render: (text: number) =>
          text && moment(text).format('YYYY-MM-DD HH:mm'),
      },
      {
        key: 'receiveMan',
        dataIndex: 'receiveMan',
        title: '收件人',
      },
      {
        key: 'number',
        title: '结算件数',
      },
      {
        key: 'finalPrice',
        dataIndex: 'finalPrice',
        title: '最终结算金额',
      },
    ],
  },
}

const AddOrderModal = (props: Props) => {
  const { open, type, ...restProps } = props
  const {
    hooksState,
    handleSearchClick,
    onChangeCheck,
    modalSubmit,
    loadMoreData,
  } = useAddOrderModalHook(props)
  const { orderData, loading, pagination, checkedKeys } = hooksState

  return (
    <CustomModal
      width={770}
      bodyStyle={{ padding: 16 }}
      {...restProps}
      open={open}
      title="新增订单"
      okText="提交"
      modalSubmit={modalSubmit}
      useOverrideTitle={false}
    >
      <Row gutter={[0, 8]}>
        <Col span={24}>
          <Search
            fieldsData={
              type === 'lander'
                ? ['orderNo', 'customer', 'platform']
                : ['supplierOrderCode']
            }
            onSearch={handleSearchClick}
            keyName={
              type === 'lander' ? 'RECONCILABLEORDERS' : 'SUPPLIERINVOICEENTRY'
            }
            ScreenKey={
              type === 'lander' ? 'RECONCILABLEORDERS' : 'SUPPLIERINVOICEENTRY'
            }
            hideScheme
          />
        </Col>
        <Col span={24}>
          <InfiniteScroll
            dataLength={orderData.length}
            next={loadMoreData}
            hasMore={orderData.length < pagination.totalCount}
            loader={<Spin spinning />}
            endMessage="已全部加载~"
            height={400}
          >
            <TableAntd
              dataSource={orderData}
              loading={loading}
              listColumn={
                columsData[type === 'lander' ? '电商供应商订单' : '供应商订单']
                  .columns
              }
              scroll={{
                y: 'auto',
              }}
              onChangeCheck={onChangeCheck}
              defaultlist={checkedKeys}
              scrollStyle={{
                height: 'auto',
              }}
            />
          </InfiniteScroll>
        </Col>
      </Row>
    </CustomModal>
  )
}

export default AddOrderModal
/*
 * @Descripttion: 新增订单弹窗
 * @Author: renbh
 * @Date: 2023-07-03 14:19:47
 * @LastEditors: 曹博
 * @LastEditTime: 2023-12-01 16:38:00
 */

import CustomModal from '../../../../components/ModalUser'
import { Col, Row, Spin } from 'antd'
import Search from '../../../../components/SearchFilter'
import useAddOrderModalHook, { Props } from './hooks'
import moment from 'moment'
import InfiniteScroll from 'react-infinite-scroll-component'
import TableAntd from '../../../../components/TableAntd'
import { toAssureOperationRender } from '../../../InvoiceEntry/SupplierInvoice'

const columsData = {
  电商供应商订单: {
    columns: [
      {
        key: 'orderNo',
        dataIndex: 'orderNo',
        title: '客户订单号',
        width: 100,
        ellipsis: true,
      },
      {
        key: 'customer',
        dataIndex: 'customer',
        title: '客户名称',
        width: 100,
        ellipsis: true,
      },
      {
        key: 'titleOfTheContract',
        dataIndex: 'titleOfTheContract',
        title: '签约主体',
      },
      {
        key: 'platform',
        dataIndex: 'platform',
        title: '下单平台',
        width: 100,
        ellipsis: true,
      },
      {
        key: 'orderTime',
        dataIndex: 'orderTime',
        title: '下单时间',
        width: 100,
        render: (text: any) => moment(text).format('YYYY-MM-DD HH:mm:ss'),
        ellipsis: true,
      },
      {
        key: 'finalPrice',
        dataIndex: 'finalPrice',
        title: '最终结算金额',
        width: 100,
        ellipsis: true,
      },
    ],
  },
  供应商订单: {
    columns: [
      {
        key: 'code',
        title: '采购订单号',
        render: toAssureOperationRender,
      },
      {
        key: 'createTime',
        dataIndex: 'createTime',
        title: '创建时间',
        render: (text: number) =>
          text && moment(text).format('YYYY-MM-DD HH:mm'),
      },
      {
        key: 'receiveMan',
        dataIndex: 'receiveMan',
        title: '收件人',
      },
      {
        key: 'number',
        title: '结算件数',
      },
      {
        key: 'finalPrice',
        dataIndex: 'finalPrice',
        title: '最终结算金额',
      },
    ],
  },
}

const AddOrderModal = (props: Props) => {
  const { open, type, ...restProps } = props
  const {
    hooksState,
    handleSearchClick,
    onChangeCheck,
    modalSubmit,
    loadMoreData,
  } = useAddOrderModalHook(props)
  const { orderData, loading, pagination, checkedKeys } = hooksState

  return (
    <CustomModal
      width={770}
      bodyStyle={{ padding: 16 }}
      {...restProps}
      open={open}
      title="新增订单"
      okText="提交"
      modalSubmit={modalSubmit}
      useOverrideTitle={false}
    >
      <Row gutter={[0, 8]}>
        <Col span={24}>
          <Search
            fieldsData={
              type === 'lander'
                ? ['orderNo', 'customer', 'platform']
                : ['supplierOrderCode']
            }
            onSearch={handleSearchClick}
            keyName={
              type === 'lander' ? 'RECONCILABLEORDERS' : 'SUPPLIERINVOICEENTRY'
            }
            ScreenKey={
              type === 'lander' ? 'RECONCILABLEORDERS' : 'SUPPLIERINVOICEENTRY'
            }
            hideScheme
          />
        </Col>
        <Col span={24}>
          <InfiniteScroll
            dataLength={orderData.length}
            next={loadMoreData}
            hasMore={orderData.length < pagination.totalCount}
            loader={<Spin spinning />}
            endMessage="已全部加载~"
            height={400}
          >
            <TableAntd
              dataSource={orderData}
              loading={loading}
              listColumn={
                columsData[type === 'lander' ? '电商供应商订单' : '供应商订单']
                  .columns
              }
              scroll={{
                y: 'auto',
              }}
              onChangeCheck={onChangeCheck}
              defaultlist={checkedKeys}
              scrollStyle={{
                height: 'auto',
              }}
            />
          </InfiniteScroll>
        </Col>
      </Row>
    </CustomModal>
  )
}

export default AddOrderModal
